<template>
  <div id="app">
    <Layout />
    <ModalRoot />
  </div>
</template>

<script>
import Layout from "@/components/layout/Layout";
import ModalRoot from "@/components/elements/ModalRoot.vue";

export default {
  name: "app",
  components: {
    Layout,
    ModalRoot
  }
};
</script>
<style src="@/assets/css/main.css" />
